import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const QUICK_ACTIONS = [
  {
    icon: "✈️",
    label: "Find Flights",
    sub: "Search domestic & international flights",
    go: (navigate) => navigate("/?tab=flight"),
  },
  {
    icon: "🏨",
    label: "Search Hotels",
    sub: "Find hotels at the best prices",
    go: (navigate) => navigate("/?tab=hotel"),
  },
  {
    icon: "🚌",
    label: "Find Buses",
    sub: "5000+ routes across India",
    go: (navigate) => navigate("/?tab=bus"),
  },
  {
    icon: "🔥",
    label: "Best Deals & Offers",
    sub: "See today's top travel offers",
    go: (navigate) => navigate("/Offers"),
  },
  {
    icon: "🧳",
    label: "My Bookings",
    sub: "Check status of your trips",
    go: (navigate) => {
      const token = localStorage.getItem("token");
      navigate(token ? "/dashboard?tab=bookings" : "/login/customer");
    },
  },
  {
    icon: "📞",
    label: "Help & Support",
    sub: "Chat with us on WhatsApp",
    go: () => window.open("https://wa.me/919266424809", "_blank", "noopener,noreferrer"),
  },
];

export default function RasutripAssistant() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const goToTabOnHome = (tabType) => {
    if (location.pathname === "/") {
      document.querySelector(".slider-container")?.scrollIntoView({ behavior: "smooth" });
      window.dispatchEvent(new CustomEvent("setActiveTab", { detail: { tabType } }));
    } else {
      navigate(`/?tab=${tabType}`);
    }
    setOpen(false);
  };

  const handleAction = (action) => {
    if (action.label === "Find Flights") return goToTabOnHome("flight");
    if (action.label === "Search Hotels") return goToTabOnHome("hotel");
    if (action.label === "Find Buses") return goToTabOnHome("bus");
    action.go(navigate);
    setOpen(false);
  };

  return (
    <>
      {/* Floating launcher */}
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="Open Bachatwali Ticket Assistant"
        className="fixed z-50 right-4 sm:right-6 bottom-[76px] lg:bottom-6 h-14 w-14 rounded-full bg-gradient-to-br from-brand-500 to-brand-700 text-white shadow-[0_8px_24px_rgba(2, 126, 246,0.4)] flex items-center justify-center hover:scale-105 active:scale-95 transition-transform"
      >
        {open ? (
          <i className="fa-solid fa-xmark text-lg" />
        ) : (
          <i className="fa-solid fa-comment-dots text-xl" />
        )}
      </button>

      {open && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black/20 sm:bg-transparent"
            onClick={() => setOpen(false)}
          />
          <div className="fixed z-50 right-0 sm:right-6 bottom-0 sm:bottom-[144px] w-full sm:w-[380px] max-h-[80vh] sm:max-h-[560px] bg-white rounded-t-3xl sm:rounded-3xl shadow-[0_24px_64px_rgba(20,22,29,0.28)] flex flex-col overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-br from-brand-600 to-brand-800 px-5 py-5 text-white shrink-0">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-white/15 flex items-center justify-center text-lg">
                  🤖
                </div>
                <div>
                  <p className="font-bold text-[15px] leading-tight">Bachatwali Ticket Assistant</p>
                  <p className="text-xs text-white/75">Your smart travel helper</p>
                </div>
              </div>
            </div>

            {/* Body */}
            <div className="flex-1 overflow-y-auto px-5 py-5 bg-ink-50">
              <div className="bg-white rounded-2xl rounded-tl-sm px-4 py-3 shadow-sm mb-5 max-w-[85%]">
                <p className="text-sm text-ink-700 leading-relaxed">
                  Hi! 👋 I can help you find flights, hotels or buses, check offers, or get support.
                  What would you like to do?
                </p>
              </div>

              <div className="space-y-2.5">
                {QUICK_ACTIONS.map((a) => (
                  <button
                    key={a.label}
                    onClick={() => handleAction(a)}
                    className="w-full flex items-center gap-3 bg-white rounded-xl p-3.5 text-left border border-ink-100 hover:border-brand-300 hover:bg-brand-50/40 transition"
                  >
                    <span className="text-xl shrink-0">{a.icon}</span>
                    <span className="min-w-0">
                      <span className="block text-sm font-semibold text-ink-900">{a.label}</span>
                      <span className="block text-xs text-ink-500 truncate">{a.sub}</span>
                    </span>
                    <i className="fa-solid fa-chevron-right text-ink-300 text-xs ml-auto shrink-0" />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
